import React, { useMemo } from 'react';
import { View } from '../../../../../../components/Common/react-native-components';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import TopicPlot from '../../../../../../components/Common/TopicPlot';
import get from 'lodash/get';

const ReviewTopicPlot = props => {
  const { itemData, type, isLoading = false, onTopicClick, widgetData } = props;

  const noData = useMemo(() => {
    return !(get(itemData, 'top_topics.length') || get(itemData, 'bottom_topics.length'));
  }, [itemData]);


  const barChartDefaultData = get(widgetData, "barChartDefaultData", null)
  const colorRules = {
    ranges: [
      {
        min: 1,
        max: 999999999,
        color: '#8ACA90'
      },
      {
        min: 0,
        max: 1,
        color: '#E8F7EB'
      },
      {
        min: -1,
        max: 0,
        color: '#F5D6D6'
      },
      {
        min: -999999999,
        max: -1,
        color: '#E16067'
      }
    ]
  };

  function renderContent() {
    switch (type) {
      case 'TABLE':
        return (
          <TopicPlot
            onTopicClick={onTopicClick}
            colorRules={get(widgetData, 'colorRules') || colorRules}
            topicData={itemData || {}}
          />
        );
      case 'BAR':
        return (
          <TopicPlot
            barChartDefaultData={barChartDefaultData}
            onTopicClick={onTopicClick}
            colorRules={get(widgetData, 'colorRules') || colorRules}
            topicData={itemData || {}}
            isChartView={true}
          />
        );
      default:
        return null;
    }
  }
  if (noData && !isLoading) {
    return <GenericNoData />;
  }

  return <View>{!isLoading && renderContent()}</View>;
};

export default ReviewTopicPlot;
